import { useTranslation } from 'react-i18next'

import { Chip } from '@reveni-io/reveni-ui'

import { getChips } from './helpers'
import * as Styles from './styles'

const SelectedFilters = ({
  filters,
  onDeleteFilter,
  onClickFilter,
  returnReasons = [],
  rejectReasons = [],
  forReviewReasons = [],
  regions = [],
  productCategories = [],
  carriers = [],
  carrierServices = [],
  productCollections = [],
  productTypes = [],
  locations = [],
  deliveryMethods = [],
  policyRules = [],
  readOnly,
}) => {
  const { t, i18n } = useTranslation()
  const chips = getChips({
    t,
    language: i18n.language,
    filters,
    returnReasons,
    rejectReasons,
    regions,
    productCategories,
    carriers,
    productCollections,
    locations,
    carrierServices,
    deliveryMethods,
    productTypes,
    policyRules,
    forReviewReasons,
  })

  if (!chips.length) return null

  return (
    <Styles.Container>
      {chips.map(chip => (
        <Chip
          onClick={!readOnly && (() => onClickFilter(chip.name))}
          key={chip.label}
          label={chip.label}
          Icon={chip.Icon}
          onDelete={!readOnly && (() => onDeleteFilter(chip.name))}
        />
      ))}
    </Styles.Container>
  )
}

export default SelectedFilters
